import axios from "axios";

export const getVehicleInformation = (vehicleId) => {
  //console.log('getVehicleInformation', params);
  return axios
    .get("/ruc/v3/vehicle/" + vehicleId, {
      //headers: createApiConfig(token),
    })
    .then((response) => {
      //console.log('getVehicleInformation.response', response);
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};

export const getVehicleLastLocation = (
  pageNo,
  pageSize,
  vehicleType,

) => {
  let params = {};
  if (pageNo !== "") {
    params = { ...params, pageNo: pageNo };
  }
  if (pageSize !== "") {
    params = { ...params, pageSize: pageSize };
  }

  if (vehicleType === 2) {
    params = { ...params, rucMonkeyVehicleTypes: "2" };
  } else if (vehicleType === 3) {
    params = { ...params, rucMonkeyVehicleTypes: "3,4" };
  } else if (vehicleType > 0) {
    params = { ...params, rucMonkeyVehicleTypes: vehicleType };
  }

  //console.log('params', params);
  return axios
    .get("/gatereader/v3/vehicle/distancerecord/last", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


// Fetches EVERY vehicle's last position, not just the first page. The distancerecord/last endpoint
// is paginated (Paging.TotalNumberOfPages); the Locate page used to request a single 500-row page
// and silently drop the rest of a larger fleet. This requests page 1 to learn the page count, then
// fetches the remaining pages in parallel and concatenates the results.
export const getAllVehicleLastLocation = async (pageSize = 500, vehicleType) => {
  const first = await getVehicleLastLocation(1, pageSize, vehicleType);
  const data = Array.isArray(first?.Data) ? [...first.Data] : [];

  const totalPages = Number(first?.Paging?.TotalNumberOfPages) || 1;
  if (totalPages > 1) {
    const remainingPages = [];
    for (let p = 2; p <= totalPages; p += 1) remainingPages.push(p);

    const responses = await Promise.all(
      remainingPages.map((p) => getVehicleLastLocation(p, pageSize, vehicleType))
    );
    responses.forEach((res) => {
      if (Array.isArray(res?.Data)) data.push(...res.Data);
    });
  }

  return { Data: data, Paging: first?.Paging };
};


export const getVehicleHistory = (
  pageNo,
  pageSize,
  vehicleId,
  startDate,
  endDate,
  maxId
) => {
  let params = { startDate: startDate, endDate: endDate };
  //let params = {'startDate': '2020-04-24', 'endDate': '2020-04-25'};

  if (pageNo !== "") {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== "") {
    params = { ...params, pageSize: pageSize };
  }

  if (maxId > 0) {
    params = { ...params, maxId: maxId };
  }

  return axios
    .get("/gatereader/v3/vehicle/" + vehicleId + "/distancerecord/history", {
      //headers: createApiConfig(token),
      params: params,
    })
    .then((response) => {

      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};


export const getGeoLocations = (pageNo, pageSize) => {
  //console.log('getGeoLocations.start', pageNo, pageSize);
  let params = {};

  if (pageNo !== "") {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== "") {
    params = { ...params, pageSize: pageSize };
  }
  
  return axios
    .get("/ruc/v3/geography/geoboundary", {
      //headers: createApiConfig(token),
      params: params,
    })
    .then((response) => {
      //console.log('getGeoLocations.response', response);
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};



export const getHistoryReportsFile = (stationId, startDate, endDate) => {

  const params = { startDateTime: startDate, endDateTime: endDate };

  return axios
    .get("/weather/v1/weatherstation/" + stationId + "/weatherrecord/csv", {
      params: params,
      responseType: 'blob',
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};
